function bootstrapTooltip() {
  return {
    restrict: "A",
    scope: {
      bootstrapTooltip: "@",
    },
    link: function (scope, element) {
      element.tooltip({
        trigger: "hover",
        title: scope.bootstrapTooltip,
      });
    },
  };
}

export default bootstrapTooltip;
